import React, { useState, useEffect, useCallback } from 'react';
import Header from '../../components/Header';
import { InputText } from 'primereact/inputtext';
import { Link } from 'react-router-dom';
import { Checkbox } from 'primereact/checkbox';
import { DocumentTextIcon } from '@heroicons/react/24/outline';
import moment from 'moment';
import PDFViewer from '../../components/pdfViewer';
import { DataStore, Storage } from 'aws-amplify';
import { Employee, Handbook, HandbookAssignee } from '../../models';
import { Handbook_Status } from '../../helper/enum';
import { toast } from 'react-toastify';
import { reactLocalStorage } from 'reactjs-localstorage';

const EmployeeAgreementHandbook = () => {
  const [checked, setChecked] = useState(false);
  const [pdfUrl, setPdfUrl] = useState('');
  const empID = reactLocalStorage.get('empID');
  const [employeeDetails, setEmployeeDetails] = useState({});
  const [handbookData, setHandbookData] = useState({});
  const [assigneeData, setAssigneeData] = useState({});

  const getEmployeeDetails = useCallback(async () => {
    if (!empID) return;

    try {
      const empDetails = await DataStore.query(Employee, empID);

      if (empDetails) {
        setEmployeeDetails(empDetails);
        getPdfUrl(empDetails.id);
      }
    } catch (error) {
      console.log(error);
    }
  }, []);
  const getPdfUrl = async empId => {
    try {
      const predicate = c => c.emp_id.eq(empId);
      const Assignee = await DataStore.query(HandbookAssignee, predicate);
      const sortedData = [...Assignee].sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));
      setAssigneeData(sortedData[0]);
      const handbookData = await DataStore.query(Handbook, sortedData[0].handbook_id);
      setHandbookData(handbookData);
      const filePath = 'handbook/' + handbookData?.file_path;
      const result = await Storage.get(filePath, { download: false, expires: 20000, cacheControl: 'no-cache' });
      if (result) {
        setPdfUrl(result);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const handleConfirm = async () => {
    let id;
    try {
      id = toast.loading('Confirming...');
      const original = await DataStore.query(HandbookAssignee, assigneeData.id);
      const res = await DataStore.save(
        HandbookAssignee.copyOf(original, updated => {
          updated.acknowledge_date = moment().format('YYYY-MM-DD');
          updated.status = Handbook_Status.ACKNOWLEDGE;
        })
      );

      if (res) {
        setAssigneeData(res);
        toast.success('Success Fully Confirmed !');
      }
    } catch (error) {
      toast.error('Something went wrong !');
    } finally {
      toast.dismiss(id);
    }
  };
  useEffect(() => {

    getEmployeeDetails();


  }, [getEmployeeDetails]);


  const isDisabledConfirmBtn = () => {
    if (assigneeData?.acknowledge_date) return true;
    if (!checked) return true;
    return false;
  };
  return (
    <>
      <Header />
      <div className="">
        <div className="grid grid-cols-1  md:grid-cols-6">
          <div className="col-span-4">
            <div className="max-w-2xl mx-auto">
              <div className="py-5 lg:flex lg:items-center lg:justify-between">
                <div className="flex-1 min-w-0 px-3">
                  <h6 className="flex items-center text-2xl font-semibold leading-7 text-gray-600 sm:truncate sm:tracking-tight">
                    Employee {employeeDetails?.employee_code} {employeeDetails?.employee_name}
                  </h6>
                  <p>Acknowledgement</p>
                  <h6 className="flex items-center mt-4">
                    <DocumentTextIcon className="w-4 h-4 me-1" aria-hidden="true" /> {handbookData?.file_path}
                  </h6>
                  <div className="bg-[#eeeff0] py-4 px-6 mt-2 employee_handbookss">
                    <div className="p-5 text-center bg-white">
                      <div className="flex justify-center overflow-x-auto overflow-y-scroll h-96">
                        <PDFViewer pdf={pdfUrl} />
                      </div>
                    </div>
                  </div>
                  <div className="flex justify-center mt-2">
                    <Link to={pdfUrl} className="text-center custmBtn white radius8 border border-[#D0D5DD] rounded-md">
                      Download
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="col-span-2 bg-white">
            <div className="px-4 right_box">
              <div className="mt-2 mb-1">
                <label className="text-[#344054] text-sm md:text-[1vw] font-medium pb-3" htmlFor="username">
                  Handbook Name
                </label>
                <div className="mt-2">
                  <InputText
                    value={
                      handbookData?.handbook_name
                    }
                    id="username"
                    disabled
                    placeholder="Hr"
                    className="w-full placeholder:text-[#667085] h-10"
                    aria-describedby=""
                  />
                </div>
              </div>

              <div className="mt-2 mb-1">
                <label className="text-[#344054] text-sm md:text-[1vw] font-medium pb-3" htmlFor="username">
                  Date to be Acknowledge
                </label>
                <div className="mt-2">
                  <InputText
                    value={moment(handbookData.due_date).format('MM/DD/YYYY')}
                    id="username"
                    disabled
                    placeholder="03/19/2023"
                    className="w-full placeholder:text-[#667085] h-10"
                    aria-describedby=""
                  />
                </div>
              </div>
              <div className="flex p-3 mt-3 align-items-start box-checks">
                <Checkbox
                  inputId="checks1"
                  // disabled={isDisabledConfirmBtn()}
                  name=""
                  value="checks"
                  onChange={e => setChecked(e.checked)}
                  checked={checked}
                />
                <label htmlFor="checks1" className="ml-2 text-[14px] xl:text-[1vw]">
                  I have received, read, understand and agree to abide by this Acceptable Use Agreement, BP/AR 4040 -
                  Employee Use Of Technology, and other applicable laws and district policies and regulations governing
                  the use of district technology. I understand that there is no expectation of privacy when using
                  district technology or when my personal electronic devices use district technology. I further
                  understand that any violation may result in revocation of users privileges, disciplinary action,
                  and/or appropriate legal action. I hereby release the district and its personnel from any and all
                  claims and damages arising from my use of district technoloy or from the failure of any technology
                  protection measures employed by the district.
                </label>
              </div>
            </div>
            <div className="flex justify-end gap-3 px-4 mt-3 mb-3 grow">
              <Link
                to="/"
                className=" py-2 px-5 bg-white text-[#344054] transition ease-in duration-200 text-[14px] text-center font-medium  shadow-md focus:outline-none leading-6  justify-center rounded-lg border border-[#D0D5DD] rounded-md dark:bg-[#333231] dark:border-[#333231] dark:text-[#FFFFFF]"
              >
                Cancel
              </Link>
              <button
                onClick={handleConfirm}
                disabled={isDisabledConfirmBtn()}
                className="text-center custmBtn disabled:bg-slate-500 blue radius8"
              >
                Confirm
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default EmployeeAgreementHandbook;
